/**
 * Tabs component
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// Library
import React, { useEffect, useState } from 'react';

// Component
import { TabItem } from './TabItem';

// Styles
import styles from './tabs.module.scss';

/**
 * Interface for Tabs props
 */
interface TabsProps {
	/**
	 * Custom styles of the button
	 */
	customStyles?: string;
	/**
	 * Allow parent component to control which is currently selected
	 * When component is rendered, this is the default tab that is selected
	 */
	selectedTab?: string;
	/**
	 * The names of the tabs that will be rendered
	 */
	tabs: string[];
	/**
	 * Function that handles onClick event
	 */
	handleClick?: (name: string) => void;
}
/**
 * Navigational component that allows users to easily swap pages
 * @param {TabsProps} Prop
 * @returns  several elements with onClick lay out horizontally
 */
export const Tabs = ({ tabs, handleClick, selectedTab = '', customStyles }: TabsProps) => {
	const [curTab, setCurTab] = useState<string>(selectedTab || tabs[0]);

	useEffect(() => {
		setCurTab(selectedTab);
	}, [selectedTab]);

	return (
		<div role="tablist" className={[styles.wrapper, customStyles].join(' ').trim()}>
			{tabs.map(tab => (
				<TabItem
					key={tab}
					name={tab}
					selected={tab === curTab}
					handleClick={name => {
						setCurTab(name);
						if (handleClick) handleClick(name);
					}}
				/>
			))}
		</div>
	);
};
